<template>

<div class="wardrobe-main l_specs">

  <div class="wardrobe-specs">

    <div class="wardrobe-spec l_w40">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Size and Shape</p>
        <p class="wardrobe-spec-text" v-if="props.item.specs.width && props.item.specs.height">
          Width: <span v-html="`${props.item.specs.width}mm`"></span><br />
          Height: <span v-html="`${props.item.specs.height}mm`"></span><br />
          Overall Depth: <span>600mm</span>
          <template v-if="props.item.specs.topId">
            <br />Top: <span v-html="props.item.data.top.title"></span>
          </template>
          <template v-if="props.item.specs.levelsOut">
            <br />Levels are out more than 8mm
            <template v-if="props.item.specs.widthTop && props.item.specs.widthMiddle && props.item.specs.widthBottom">
              <br />Widths: <span>T <span v-html="`${props.item.specs.widthTop}mm`"></span> / M <span v-html="`${props.item.specs.widthMiddle}mm`"></span> / B <span v-html="`${props.item.specs.widthBottom}mm`"></span></span>
            </template>
            <template v-if="props.item.specs.heightLeft && props.item.specs.heightMiddle && props.item.specs.heightRight">
              <br />Heights: <span>L <span v-html="`${props.item.specs.heightLeft}mm`"></span> / M <span v-html="`${props.item.specs.heightMiddle}mm`"></span> / R <span v-html="`${props.item.specs.heightRight}mm`"></span></span>
            </template>
            <template v-if="props.item.specs.runOutDirection && props.item.specs.runOutAmount">
              <br />Run-out: <span> <span v-html="`${props.item.specs.runOutDirection}`"></span> <span v-html="`${props.item.specs.runOutAmount}mm`"></span></span>
            </template>
          </template>
        </p>
      </div>
    </div>

    <div class="wardrobe-spec l_w30">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Wall Space</p>
        <p class="wardrobe-spec-text" v-html="props.item.data.wallSpace.title" v-if="props.item.data.wallSpace">
        </p>
      </div>
    </div>

    <div class="wardrobe-spec l_w30">
      <div class="wardrobe-spec-inner">
        <img :src=props.item.data.layout.image alt="" class="wardrobe-image" v-if="props.item.data.layout">
        <Plan
          v-else
          :item="props.item"
          :layout="props.item.productLayout.slug"
          :wallspace="props.item.data.wallSpace.slug"
          :sections="props.item.sections"
          :interactive="false"
          custom-class="plan--minimal plan--letterbox"></Plan>
        <!-- <img :src=props.item.data.wallSpace.image alt="" class="wardrobe-image"> -->
      </div>
    </div>

    <div class="wardrobe-specbreak"></div>

    <div class="wardrobe-spec l_w40">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Internals</p>
        <p class="wardrobe-spec-text">
          Configuration: <span v-html="props.item.data.config.title" v-if="props.item.data.config"></span>
          <template v-if="props.item.specs.requireInternals"><br />Material: <span>White&nbsp;Melamine</span></template><br />
          Internal Depth: <span>442mm</span>
        </p>
      </div>


      <div class="wardrobe-spec-inner l_flush-top" v-if="props.item.specs.requireInternals">
        <p class="wardrobe-spec-title">Internal Hardware</p>

        <div class="thumbpanel" @click.stop="lightboxActivate($event, props.item.data.hardware, 'hardware')" v-if="props.item.data.hardware">
          <div class="thumbpanel-thumb">
            <div class="thumbpanel-image" :style="`background-image: url(${props.item.data.hardware.image});`" v-if="props.item.data.hardware"></div>
            <div class="thumbpanel-none" v-else></div>
          </div>
          <div class="thumbpanel-main">
            <span v-html="props.item.data.hardware.title" v-if="props.item.data.hardware"></span>
            <span v-else>Not selected</span>
            <div class="wardrobe-spec-help" v-if="props.item.data.hardware">
              <svg class="icon"><use xlink:href="#zoom"></use></svg>
            </div>
          </div>
        </div>

        <p class="wardrobe-spec-text l_light" v-else>Not required</p>

      </div>


      <div class="wardrobe-spec-inner l_flush-top" v-if="props.item.specs.requireInternals && props.item.data.drawerType && props.item.data.config.hasDrawers">
        <p class="wardrobe-spec-title">Drawer Type</p>

        <div class="thumbpanel" @click.stop="lightboxActivate($event, props.item.data.drawerType, 'drawerType')" v-if="props.item.data.drawerType">
          <div class="thumbpanel-thumb">
            <div class="thumbpanel-image" :style="`background-image: url(${props.item.data.drawerType.image});`" v-if="props.item.data.drawerType"></div>
            <div class="thumbpanel-none" v-else></div>
          </div>
          <div class="thumbpanel-main">
            <span v-html="props.item.data.drawerType.title" v-if="props.item.data.drawerType"></span>
            <span v-else>Not selected</span>
            <div class="wardrobe-spec-help" v-if="props.item.data.drawerType">
              <svg class="icon"><use xlink:href="#zoom"></use></svg>
            </div>
          </div>
        </div>

        <p class="wardrobe-spec-text l_light" v-else>Not required</p>

      </div>
    </div>

    <div class="wardrobe-spec l_w60">
      <div class="wardrobe-spec-inner">
        <button @click.stop="lightboxActivate($event, props.item.data.config, 'interior')">
          <img :src=props.item.data.config.image alt="" class="wardrobe-image">
        </button>
      </div>
    </div>

    <div class="wardrobe-specbreak"></div>

    <div class="wardrobe-spec l_w40">
      <div class="wardrobe-spec-inner">

        <p class="wardrobe-spec-title">Door Panels</p>

        <template v-if="props.item.specs.doors && props.item.specs.requireDoors">
          <div class="thumbpanel" v-for="n in props.item.specs.doors" :index="props.item.data['panel' + n]" @click.stop="lightboxActivate($event, props.item.data['panel' + n], 'panel' + n)">
            <div class="thumbpanel-thumb">
              <div class="thumbpanel-image" :style="`background-image: url(${props.item.data['panel' + n].image});`" v-if="props.item.data['panel' + n]"></div>
            <div class="thumbpanel-none" v-else></div>
            </div>
            <div class="thumbpanel-main">
              <span v-html="`Door ${n}: ${props.item.data['panel' + n].title}`" v-if="props.item.data['panel' + n]"></span>
              <div class="wardrobe-spec-help">
                <svg class="icon"><use xlink:href="#zoom"></use></svg>
              </div>
            </div>
          </div>
        </template>

        <p class="wardrobe-spec-text l_light" v-else>Not required</p>

      </div>
    </div>

    <div class="wardrobe-spec l_w60">
      <div class="wardrobe-spec-inner">

        <p class="wardrobe-spec-title">Door Frames</p>

        <div class="thumbpanel" @click.stop="lightboxActivate($event, props.item.data.frames, 'frames')" v-if="props.item.data.frames">
          <div class="thumbpanel-thumb">
            <div class="thumbpanel-image" :style="`background-image: url(${props.item.data.frames.image});`" v-if="props.item.data.frames"></div>
            <div class="thumbpanel-none" v-else></div>
          </div>
          <div class="thumbpanel-main">
            <span v-html="props.item.data.frames.title" v-if="props.item.data.frames"></span>
            <span v-else>Not selected</span>
            <div class="wardrobe-spec-help" v-if="props.item.data.frames">
              <svg class="icon"><use xlink:href="#zoom"></use></svg>
            </div>
          </div>
        </div>

        <p class="wardrobe-spec-text l_light" v-else>Not required</p>

        <p class="wardrobe-spec-title" style="margin-top: 20px;">Top and Bottom Tracks</p>

        <div class="thumbpanel" @click.stop="lightboxActivate($event, props.item.data.frames, 'frames')" v-if="props.item.data.frames">
          <div class="thumbpanel-thumb">
            <div class="thumbpanel-image" :style="`background-image: url(${props.item.data.frames.image});`" v-if="props.item.data.frames"></div>
            <div class="thumbpanel-none" v-else></div>
          </div>
          <div class="thumbpanel-main">
            <span v-html="props.item.data.frames.title" v-if="props.item.data.frames"></span>
            <span v-else>Not selected</span>
            <div class="wardrobe-spec-help" v-if="props.item.data.frames">
              <svg class="icon"><use xlink:href="#zoom"></use></svg>
            </div>
          </div>
        </div>

        <p class="wardrobe-spec-text l_light" v-else>Not required</p>

      </div>
    </div>


    <div class="wardrobe-specbreak" v-if="props.item.includedItemsList"></div>

    <div class="wardrobe-spec l_w100" v-if="props.item.includedItemsList">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Included Items</p>
        <p class="wardrobe-spec-text l_light l_itemised">
          <span class="l_text-blue">Board materials in white melamine</span><br />
          <span v-html="props.item.includedItemsList"></span>
        </p>
      </div>
    </div>


    <div class="wardrobe-specbreak" v-if="props.item.adjusters && props.item.adjusters.length && props.item.valid"></div>

    <div class="wardrobe-spec" v-if="props.item.adjusters && props.item.adjusters.length && props.item.valid">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Additional Items</p>
        <p class="wardrobe-spec-text l_light">
          <span v-for="adjuster in props.item.adjusters">
            <span v-html="adjuster.title"></span>&nbsp;
            <span v-html="adjuster.totalCost"></span>
            <br />
          </span>
        </p>
      </div>
    </div>

  </div>

</div>

</template>

<script setup>
const props = defineProps([
  'item'
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const emit = defineEmits(['selectOption'])

function lightboxActivate(e, item, zoomType) {
  emit('lightboxActivate', item, zoomType);
  e.preventDefault();
  return false;
}
</script>
